import {ConfigInfo} from "@cm/template-nodes"

export type SectionEntry = {kind: "item"; config: ConfigInfo} | {kind: "section"; title: string; configs: ConfigInfo[]}

// Groups ConfigInfo descriptors that share a sectionTitle into a single section. The
// section is emitted at the position of its first member — since the input is already
// sorted by `order` ascending, that's the min-order one, satisfying "section order =
// min child order". A lone descriptor with a sectionTitle stays an item.
export function groupBySectionTitle(configs: readonly ConfigInfo[]): SectionEntry[] {
    const indicesByTitle = new Map<string, number[]>()
    configs.forEach((config, i) => {
        const {sectionTitle} = config.props
        if (sectionTitle) {
            const list = indicesByTitle.get(sectionTitle) ?? []
            list.push(i)
            indicesByTitle.set(sectionTitle, list)
        }
    })

    const entries: SectionEntry[] = []
    for (let i = 0; i < configs.length; i++) {
        const config = configs[i]
        const {sectionTitle} = config.props
        if (sectionTitle) {
            const indices = indicesByTitle.get(sectionTitle)!
            if (indices.length === 1) {
                entries.push({kind: "item", config})
            } else if (i === indices[0]) {
                entries.push({
                    kind: "section",
                    title: sectionTitle,
                    configs: indices.map((idx) => configs[idx]),
                })
            }
        } else {
            entries.push({kind: "item", config})
        }
    }
    return entries
}
